// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__duc42","alertContainer":"index_alertContainer__Xdzgq","title":"index_title__81MYs","desc":"index_desc__dDjvT","btn":"index_btn__bqfsW"};